import { render, staticRenderFns } from "./StockBreakdownView.vue?vue&type=template&id=7ed87ba9&scoped=true"
import script from "./StockBreakdownView.vue?vue&type=script&lang=js"
export * from "./StockBreakdownView.vue?vue&type=script&lang=js"
import style0 from "./StockBreakdownView.vue?vue&type=style&index=0&id=7ed87ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed87ba9",
  null
  
)

export default component.exports